import { Pagination, PaginationProps } from "antd";
import { useTranslation } from "react-i18next";
import { ArrowLeftIcon, ArrowRightIcon } from "src/assets/icons";
import { INafutelPagination } from "src/interfaces";
import "./index.scss";

interface IProps {
  style?: React.CSSProperties;
  pagination: INafutelPagination;
  onChange: (page: number, size: number) => void;
}

function NafutelPaginationComponent({ pagination, onChange, style }: IProps) {
  const { t } = useTranslation();
  const itemRender: PaginationProps["itemRender"] = (page, type) => {
    if (type === "prev") {
      if (pagination.page === 1) return null;
      return (
        <button className="btn-control ">
          <ArrowLeftIcon height={16} />
          <span className="ps-1">{t("pagination.back")}</span>
        </button>
      );
    }
    if (type === "next") {
      if (pagination.page * pagination.size >= pagination.total) return null;
      return (
        <button className="btn-control">
          <span className="pe-1"> {t("pagination.next")}</span>
          <ArrowRightIcon height={16} />
        </button>
      );
    }
    if (type === "jump-prev" || type === "jump-next") {
      return <div className="jump-page">...</div>;
    }
    return (
      <button
        className={`item-page ${pagination.page === page ? "active" : ""}`}
      >
        {page}
      </button>
    );
  };

  return (
    <div style={style}>
      <Pagination
        className="nafutel-pagination"
        current={pagination.page || 1}
        pageSize={pagination.size || 10}
        total={pagination.total}
        responsive={true}
        showSizeChanger={false}
        onChange={(page, size) => {
          window.scrollTo(0, 0);
          onChange(page, size);
        }}
        itemRender={itemRender}
        hideOnSinglePage={true}
      />
    </div>
  );
}

export default NafutelPaginationComponent;
